<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="'一覧へ戻る'"
      :btnClass="'btn-secondary'"
      :btnToLink="'/payment_setting/list'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <div class="card mb-4">
      <div class="card-header bg-light">
        <h5 class="mb-0">会員情報</h5>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-2">
            <p class="fw-bold">ライセンスNo</p>
          </div>
          <div class="col-4">
            <p>{{ member_obj.license_no || '---' }}</p>
          </div>
          <div class="col-2">
            <p class="fw-bold">都道府県</p>
          </div>
          <div class="col-4">
            <p>{{ member_obj.pref_label || '---' }}</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="fw-bold">会員名</p>
          </div>
          <div class="col-4">
            <p>{{ member_obj.name_label || '---' }}</p>
          </div>
          <div class="col-2">
            <p class="fw-bold">カナ</p>
          </div>
          <div class="col-4">
            <p>{{ member_obj.yomi_label || '---' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <p class="fw-bold">最終更新年度</p>
          </div>
          <div class="col-4">
            <p>{{ member_obj.last_sports_year || '---' }}</p>
          </div>
          <div class="col-2">
            <p class="fw-bold">生年月日</p>
          </div>
          <div class="col-4">
            <p>{{ member_obj.birth_date_label || '---' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header bg-light">
        <h5 class="mb-0">決済設定</h5>
      </div>
      <div class="card-body">
        <h6>商品(商品マスタの一般決済カテゴリ)</h6>
        <div class="row pb-1 mb-2 border-bottom">
          <div class="col-4">
            <label class="form-label">商品名</label>
          </div>
          <div class="col-4">
            <label class="form-label">バリエーション</label>
          </div>
          <div class="col-3">
            <label class="form-label">金額</label>
          </div>
          <div class="col-1">
            <div class="pb-2">
              <button
                type="button"
                class="btn btn-light btn-sm btn-outline-secondary"
                @click="add_order"
              >
                <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div
          class="row pb-1 mb-2 border-bottom"
          v-for="(order, index) in sales_order_obj"
          :key="index"
        >
          <div class="col-4">
            <bs-select
              :options="sel_article_list"
              v-model="order.article_id"
              :null-option="false"
              :id="'Article_id' + index"
              :classParam="'form-select form-select-sm'"
            ></bs-select>
          </div>
          <div class="col-4">
            <bs-select
              :options="sel_variant_list(order.article_id)"
              v-model="order.variant_id"
              :null-option="false"
              :id="'Varaint_id' + index"
              :classParam="'form-select form-select-sm'"
              @change="chg_variant_upd_price(index)"
            ></bs-select>
          </div>
          <div class="col-3">
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="form-control"
                v-model="order.list_price"
                @change="chg_price_upd_amount"
              />
              <span class="input-group-text">円</span>
            </div>
          </div>
          <div class="col-1">
            <div class="pb-2">
              <button
                type="button"
                class="btn btn-light btn-sm btn-outline-secondary"
              >
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <form @submit.prevent="savePaymentSetting">
          <div class="row mb-3">
            <div class="col-2">
              <label for="amount" class="form-label fw-bold"
                >金額<span class="text-danger">*</span></label
              >
            </div>
            <div class="col-4">
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  id="amount"
                  v-model="payment_setting.amount"
                  required
                  min="1"
                />
                <span class="input-group-text">円</span>
              </div>
              <div
                class="form-text text-danger"
                v-if="validation_errors.amount"
              >
                {{ validation_errors.amount }}
              </div>
            </div>
            <div class="col-2">
              <label for="payment_deadline" class="form-label fw-bold"
                >決済期限</label
              >
            </div>
            <div class="col-4">
              <input
                type="date"
                class="form-control"
                id="payment_deadline"
                v-model="payment_setting.payment_deadline"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2">
              <label for="note" class="form-label fw-bold">備考</label>
            </div>
            <div class="col-10">
              <textarea
                class="form-control"
                id="note"
                v-model="payment_setting.note"
                rows="3"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 text-center"
              v-if="chk_relation_type_editable('/payment_setting/data')"
            >
              <button
                type="submit"
                class="btn btn-light btn-outline-secondary me-2"
              >
                登録する
              </button>
              <button
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="cancel"
              >
                キャンセル
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import config from '../../../const'

export default {
  name: 'PaymentSettingDataView',
  components: {
    BsPageTitle,
    BsMsgAlert,
    BsSelect
  },
  data: function () {
    return {
      fromParentTitle: '決済設定',
      alertMessage: '',
      alertClass: 'alert-info',
      member_id: null,
      member_obj: {},
      payment_setting: {
        amount: '',
        payment_deadline: '',
        note: ''
      },
      validation_errors: {
        amount: ''
      },
      article_obj: [],
      sales_order_obj: [],
      sales_order_frm_tmp: {
        id: 0,
        stat: 1,
        article_id: 0, //postする必要はなし
        // sales_id: 0,
        // application_id: '',
        variant_id: 0,
        // sports_year: 0,
        num: 1,
        list_price: 0
        // article_list: [],
        // variant_list: []
      }
    }
  },
  computed: {
    ...mapState({}),
    sel_article_list: function () {
      const tmps = []
      if (Array.isArray(this.article_obj) && this.article_obj.length > 0) {
        this.article_obj.forEach(obj => {
          const tmp = { ...obj }
          tmp.key = obj.id
          tmps.push({ ...tmp })
        })
      }
      return tmps
    },
    sel_variant_list: function () {
      const variants = this.get_variant_list
      return function (article_id) {
        if (article_id == 0) {
          return [...variants]
        }
        return [...variants].filter(variant => variant.article_id == article_id)
      }
    },
    get_variant_list: function () {
      const tmps = []
      if (Array.isArray(this.article_obj) && this.article_obj.length > 0) {
        this.article_obj.forEach(article => {
          if (Array.isArray(article.variants) && article.variants.length > 0) {
            article.variants.forEach(variant => {
              const tmp = { ...variant }
              tmp.key = variant.id
              tmp.label = variant.sub_label
              tmps.push({ ...tmp })
            })
          }
        })
      }
      return tmps
    }
  },
  async created() {
    this.member_id = this.$route.params.id
    await this.loadMemberData()
    await this.loadArticleObj()
  },
  mounted() {
    // 初期値として1ヶ月後の日付を設定
    const oneMonthLater = new Date()
    oneMonthLater.setMonth(oneMonthLater.getMonth() + 1)
    this.payment_setting.payment_deadline = this.formatDate(oneMonthLater)

    this.alertMessage = `会員「${
      this.member_obj.name_label || ''
    }」の決済設定を行います。`
  },
  methods: {
    async chg_variant_upd_price(index) {
      const sales_order_tmp = [...this.sales_order_obj]
      if (sales_order_tmp[index]) {
        const variant = this.get_variant_list.find(
          variant => variant.id == sales_order_tmp[index].variant_id
        )
        if (variant) {
          sales_order_tmp[index].unit_price = variant.default_price
          sales_order_tmp[index].list_price = variant.default_price
        }
      }
      this.sales_order_obj = sales_order_tmp
      await this.chg_price_upd_amount()
    },
    async chg_price_upd_amount() {
      let amount_tmp = 0
      const sales_order_tmp = [...this.sales_order_obj]
      if (Array.isArray(sales_order_tmp) && sales_order_tmp.length > 0) {
        sales_order_tmp.forEach(order => {
          amount_tmp += parseInt(order.list_price)
        })
      }
      const tmps = { ...this.payment_setting }
      tmps.amount = amount_tmp
      this.payment_setting = tmps
    },
    async add_order() {
      const sales_order_tmp = [...this.sales_order_obj]
      sales_order_tmp.push({ ...this.sales_order_frm_tmp })
      // sales_order_tmp.article_list = [...this.sel_article_list]
      // sales_order_tmp.variant_list = [...this.get_variant_list]
      this.sales_order_obj = sales_order_tmp
    },
    async loadArticleObj() {
      const params = {}
      params['stat'] = [1]
      params['category_id'] = 6
      await this.basicPosts_S(config.BASE_API_URL + '/article/lists', params)
        .then(async response => {
          console.log('loadArticleObj', response)
          this.article_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.article_obj = []
        })
        .finally(async () => {
          console.log('loadArticleObj finally', this.article_obj)
          this.$forceUpdate()
        })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async loadMemberData() {
      if (!this.member_id) {
        this.alertMessage = '会員IDが指定されていません。'
        this.alertClass = 'alert-danger'
        return
      }

      const params = {}
      params['id'] = this.member_id

      await this.basicPosts_S(config.BASE_API_URL + '/member/lists', params)
        .then(async response => {
          console.log('loadMemberData response', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}

          if (Object.keys(tmp_obj).length > 0) {
            // 名前の設定
            let name_label = ''
            if (tmp_obj.name_1) name_label += tmp_obj.name_1
            if (tmp_obj.name_2) name_label += tmp_obj.name_2
            if (tmp_obj.name_3) name_label += tmp_obj.name_3
            tmp_obj.name_label = name_label

            // カナの設定
            let yomi_label = ''
            if (tmp_obj.yomi_1) yomi_label += tmp_obj.yomi_1
            if (tmp_obj.yomi_2) yomi_label += tmp_obj.yomi_2
            if (tmp_obj.yomi_3) yomi_label += tmp_obj.yomi_3
            tmp_obj.yomi_label = yomi_label

            this.member_obj = tmp_obj
            this.alertMessage = `会員「${
              this.member_obj.name_label || ''
            }」の決済設定を行います。`
            this.alertClass = 'alert-info'
          } else {
            this.alertMessage = '該当する会員が見つかりませんでした。'
            this.alertClass = 'alert-danger'
          }
        })
        .catch(async err => {
          console.log(err)
          this.alertMessage = '会員データの取得に失敗しました。'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    validateForm() {
      let isValid = true
      this.validation_errors = {
        amount: ''
      }

      // 金額のバリデーション
      if (!this.payment_setting.amount) {
        this.validation_errors.amount = '金額を入力してください。'
        isValid = false
      } else if (
        isNaN(this.payment_setting.amount) ||
        this.payment_setting.amount <= 0
      ) {
        this.validation_errors.amount =
          '金額は1円以上の数値を入力してください。'
        isValid = false
      }

      return isValid
    },
    savePaymentSetting() {
      if (!this.validateForm()) {
        return
      }

      const params = {
        member_id: this.member_id,
        amount: this.payment_setting.amount,
        payment_deadline: this.payment_setting.payment_deadline,
        note: this.payment_setting.note,
        stat: 1, // 未決済状態
        sales_orders: []
      }

      if (
        Array.isArray(this.sales_order_obj) &&
        this.sales_order_obj.length > 0
      ) {
        params.sales_orders = [...this.sales_order_obj]
      }

      console.log('savePaymentSetting params', params)

      this.alertMessage = '保存中...'
      this.alertClass = 'alert-info'

      this.basicPosts_S(config.BASE_API_URL + '/payment_setting/save', params)
        .then(response => {
          console.log('savePaymentSetting response', response)

          // レスポンスオブジェクトの確認
          if (response && response.data) {
            // APIからの正常なレスポンス（status: 200）
            if (response.data.status === 200 || response.data.id) {
              this.alertMessage = '決済設定を登録しました。'
              this.alertClass = 'alert-success'

              // 成功した場合、3秒後に一覧画面に戻る
              setTimeout(() => {
                this.$router.push('/payment_setting/list')
              }, 3000)
            }
            // APIからのエラーレスポンス
            else {
              this.alertMessage =
                response.data.message || '決済設定の登録に失敗しました。'
              this.alertClass = 'alert-danger'
              console.error('API Error:', response.data)
            }
          }
          // レスポンスデータがない場合
          else {
            this.alertMessage =
              '決済設定の登録に失敗しました。レスポンスデータがありません。'
            this.alertClass = 'alert-danger'
            console.error('Invalid response:', response)
          }
        })
        .catch(err => {
          console.error('API Error:', err)
          this.alertMessage = 'APIリクエストエラーが発生しました。'
          this.alertClass = 'alert-danger'
        })
    },
    cancel() {
      //   this.$router.push('/payment_setting/list')
    }
  }
}
</script>
